import { render, staticRenderFns } from "./WebCashier.vue?vue&type=template&id=d38b4c58&scoped=true"
import script from "./WebCashier.vue?vue&type=script&lang=js"
export * from "./WebCashier.vue?vue&type=script&lang=js"
import style0 from "./WebCashier.vue?vue&type=style&index=0&id=d38b4c58&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38b4c58",
  null
  
)

export default component.exports